import type { ISwSettings } from "app/@types/ISwSettings";
import { USE_CASE_STEP_CONFIG } from "app/components/ChangeSolutionModal/config/changeSolutionSteps";
import type { ChangeSolutionStepsType } from "app/components/ChangeSolutionModal/consts";
import { trackingCategory, changeSolutionSteps } from "app/components/ChangeSolutionModal/consts";
import type { IUseCaseStepConfig, UseCaseGroupKey } from "app/components/ChangeSolutionModal/types";
import { USE_CASE_GROUPS } from "app/components/ChangeSolutionModal/types";
import { allTrackers } from "app/services/track/track";

export const getNextStep = (
    currentStep: ChangeSolutionStepsType,
    selectedSolution?: IUseCaseStepConfig,
    defaultSolution?: IUseCaseStepConfig,
): ChangeSolutionStepsType | null => {
    switch (currentStep) {
        case changeSolutionSteps.welcome:
            return changeSolutionSteps.useCase;
        case changeSolutionSteps.useCase:
            if (selectedSolution && defaultSolution?.solution !== selectedSolution?.solution) {
                return changeSolutionSteps.newSolution;
            }
            return changeSolutionSteps.currentSolution;
        default:
            return null;
    }
};

const PREVIOUS_STEP_MAP: Record<ChangeSolutionStepsType, ChangeSolutionStepsType | null> = {
    [changeSolutionSteps.welcome]: null,
    [changeSolutionSteps.useCase]: changeSolutionSteps.welcome,
    [changeSolutionSteps.newSolution]: changeSolutionSteps.useCase,
    [changeSolutionSteps.currentSolution]: changeSolutionSteps.useCase,
};

export const getPreviousStep = (currentStep: ChangeSolutionStepsType): ChangeSolutionStepsType | null =>
    PREVIOUS_STEP_MAP[currentStep] ?? null;

export const trackEvents = (action: string, eventName: string) => {
    allTrackers.dispatchTrackEvent(trackingCategory, action, eventName);
};

export const getUseCaseGroupKeyFromValue = (value: string): UseCaseGroupKey | null => {
    const entry = Object.entries(USE_CASE_GROUPS).find(([, val]) => val === value);
    return entry ? (entry[0] as UseCaseGroupKey) : null;
};

export const getDefaultSolution = (swSettings: ISwSettings): IUseCaseStepConfig | null => {
    const useCaseFromQuiz = swSettings?.user?.customData?.quiz?.UseCase;

    if (!useCaseFromQuiz) {
        return null;
    }

    const useCaseKey = getUseCaseGroupKeyFromValue(useCaseFromQuiz);
    if (!useCaseKey) {
        return null;
    }

    return USE_CASE_STEP_CONFIG[useCaseKey] ?? null;
};
